/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 43f96b2d (Wed Dec  3 21:51:26 UTC 2025)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface CompleteAgreementResponse
 */
export interface CompleteAgreementResponse {
  /**
   * The userKey from the session.
   * @type number
   * @memberof CompleteAgreementResponse
   */
  userKey: number
  /**
   * The actorKey that belong to the new actor`.
   * @type number
   * @memberof CompleteAgreementResponse
   */
  actorKey: number
}

export function CompleteAgreementResponseFromJSON(
  json: any
): CompleteAgreementResponse {
  return CompleteAgreementResponseFromJSONTyped(json, false)
}

export function CompleteAgreementResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CompleteAgreementResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    userKey: json['userKey'],
    actorKey: json['actorKey'],
  }
}

export function CompleteAgreementResponseToJSON(
  value?: CompleteAgreementResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    userKey: value.userKey,
    actorKey: value.actorKey,
  }
}
